import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';

@Pipe({ name: 'luxonTime' })
export class LuxonTimePipe implements PipeTransform {
  transform(value: any | DateTime, ...args: any[]): any {
    let [format] = args;
    if (!format) {
      format = "dd/MM/yyyy à HH'h'mm";
    }
    let datetime = null;
    if (value instanceof DateTime) {
      datetime = value;
    } else if (value) {
      value = value?.date ? value.date : value;
      datetime = DateTime.fromFormat(
        value.substring(0, 19),
        'y-LL-dd hh:mm:ss',
      );
    }
    return datetime ? datetime.toFormat(format) : null;
  }
}

@Pipe({ name: 'luxonTimeU', pure: false })
export class LuxonTimePipeU extends LuxonTimePipe implements PipeTransform {}
